export enum ETelematicsMethodType {
  REQUEST_API = "REQUEST_API",
  PERMANENT_API = "PERMANENT_API",
  TEMPORARY_API = "TEMPORARY_API",
  MANUAL = "MANUAL",
  SKIP = "SKIP",
  ASSIGN = "ASSIGN",
}
